export const configKey = {
  podcastList: "podcastList",
  additional_htmlList: "additional_htmlList",
};
